import { RouteRecordRaw } from 'vue-router'

import Welcome from '@/popup/components/views/Onboard/Welcome/Welcome.vue'
import WelcomeInfo from '@/popup/components/views/Onboard/Welcome/WelcomeInfo.vue'
import createNewAccountRoutes from '@/popup/components/views/Onboard/CreateNewAccount/createNewAccountRoutes'
import createNewAccountRoutesEmbedded from '@/popup/components/views/Onboard/EmbeddedAccount/createNewAccountRoutes'
import CreateAddress from '@/popup/components/views/Onboard/CreateAddress/CreateAddress.vue'
import CreateNewAccountFrame from '@/popup/components/views/Onboard/CreateNewAccount/CreateNewAccountFrame.vue'
import AddAccount from '@/popup/components/views/Onboard/CreateNewAccount/AddAccount.vue'
import TermsOfUse from '@/popup/components/views/Onboard/TermsOfUse/TermsOfUse.vue'
import BaseSupport from '../../views/Onboard/CreateNewAccount/BaseSupport.vue'

const onboardRoutes: Array<RouteRecordRaw> = [
  {
    path: '/create-account',
    name: 'createAccount',
    component: CreateNewAccountFrame,
    children: process.env.EMBEDDED_WALLET
      ? createNewAccountRoutesEmbedded
      : createNewAccountRoutes,
  },
  {
    path: '/create-address/:id',
    name: 'createAddress',
    component: CreateAddress,
  },
  {
    path: '/add-account',
    name: 'addAccount',
    component: AddAccount,
  },
  {
    path: '/add-base-account',
    name: 'addBaseAccount',
    component: BaseSupport,
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: Welcome,
  },
  {
    path: '/welcome-info',
    name: 'welcome-info',
    component: WelcomeInfo,
  },
  {
    path: '/terms-of-use',
    name: 'termsOfUse',
    component: TermsOfUse,
  },
]

export default onboardRoutes
